import { render } from "./auth-wololo.vue?vue&type=template&id=77c9ff07&scoped=true"
import script from "./auth-wololo.vue?vue&type=script&lang=js"
export * from "./auth-wololo.vue?vue&type=script&lang=js"

import "./auth-wololo.vue?vue&type=style&index=0&id=77c9ff07&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c9ff07"]])

export default __exports__